module.exports = __webpack_public_path__ + "static/img/ug.be11ef39.svg";